import {
  getRelativeFontSize,
  mediumFont,
  regularFont,
  theme,
} from "../../utils/styles";

const ragChatbotStyles = {
  mainContainer: {
    display: "flex",
    justifyContent: "center",
    mx: 5,
    [theme.breakpoints.down("sm")]: {
      mx: 2,
    },
  },
  mainBox: {
    p: 1,
    borderRadius: "28px",
    height: "calc(100vh - 184px)",
    background: "rgba(255, 255, 255, 0.07)",
    backdropFilter: "blur(24px)",
    border: "1px solid rgba(255, 255, 255, 0.14)",
    boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
    my: 3,
    maxWidth: "1750px",
    width: "100%",
    [theme.breakpoints.down(1311)]: {
      height: "calc(100vh - 204px)",
    },
    [theme.breakpoints.down("md")]: {
      my: 2,
      height: "calc(100vh - 209px)",
    },
    [theme.breakpoints.down("sm")]: {
      my: 3,
    },
  },
  subBox: {
    p: 3,
    pt: 1.5,
    height: "calc(100vh - 222px)",
    borderRadius: "20px",
    border: "1px solid rgba(255, 255, 255, 0.14)",
    [theme.breakpoints.down(1311)]: {
      height: "calc(100vh - 242px)",
    },
    [theme.breakpoints.down("md")]: {
      height: "calc(100vh - 247px)",
    },
    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 229px)",
      p: 1,
    },
  },
  containerScrollStyle: {
    height: "calc(100vh - 200px)",
    overflowY: "auto",
    overflowX: "hidden",
    "&::-webkit-scrollbar": {
      width: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
      border: "1px solid #FFFFFF",
      background: "#282945",
    },
    [theme.breakpoints.down(1311)]: {
      height: "calc(100vh - 220px)",
    },
    [theme.breakpoints.down("md")]: {
      height: "calc(100vh - 235px)",
    },
    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 222px)",
    },
  },
  italicTypo: {
    color: "#FFF",
    textAlign: "center",
    fontFamily: mediumFont.fontFamily,
    fontWeight: mediumFont.fontWeight,
    fontSize: "35px",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.77px",
    textTransform: "uppercase",
    margin: "0 auto",
    [theme.breakpoints.down("sm")]: {
      fontSize: "25px",
    },
  },
  scrollStyle: {
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    borderTopLeftRadius: "20px",
    borderTopRightRadius: "20px",
    height: "calc(100vh - 335px)",
    overflowY: "auto",
    overflowX: "hidden",
    padding: "10px",
    pb: 0,
    "&::-webkit-scrollbar": {
      width: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
      border: "1px solid #FFFFFF",
      background: "#282945",
    },
    [theme.breakpoints.down("sm")]: {
      p: 0,
    },
  },
  startChatMessage: {
    textAlign: "center",
    color: "#888",
    fontSize: getRelativeFontSize(3),
    marginTop: "20px",
  },
  messageBox: {
    display: "flex",
    marginBottom: "10px",
  },
  messageBoxRight: {
    justifyContent: "flex-end",
    pr: 2,
    [theme.breakpoints.down("sm")]: {
      pr: 0,
    },
  },
  messageBoxLeft: {
    justifyContent: "flex-start",
    pl: 2,
    [theme.breakpoints.down("sm")]: {
      pl: 0,
    },
  },
  message: {
    padding: "10px",
    borderRadius: "10px",
    maxWidth: "60%",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
    wordWrap: "break-word",
    whiteSpace: "pre-wrap",
    position: "relative",
  },
  messageRight: {
    backgroundColor: "#8a58cb",
    alignSelf: "flex-end",
  },
  messageLeft: {
    background: "rgba(255, 255, 255, 0.14)",
    backdropSFilter: "blur(24px)",
    border: "1px solid rgba(255, 255, 255, 0.21)",
    alignSelf: "flex-start",
  },
  messageText: {
    ...regularFont,
    fontSize: getRelativeFontSize(2),
    color: "#FFFFFF",
  },
  metaDataBox: {
    mt: 1,
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    background: "rgba(255,255,255,0.07)",
    borderRadius: "8px",
    p: "8px",
    border: "1px solid rgba(255,255,255,0.14)",
  },
  metaDataItem: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    textDecoration: "none",
    background: "rgba(138, 49, 255, 0.08)",
    borderRadius: "6px",
    p: "6px 10px",
    transition: "background 0.2s",
    cursor: "pointer",
    "&:hover": {
      background: "#8a58cb33",
    },
  },
  metaDataText: {
    color: "#8A31FF",
    fontWeight: 500,
    fontSize: getRelativeFontSize(1.7),
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "300px",
  },
  metaDataPage: {
    color: "#FFF",
    fontSize: getRelativeFontSize(1.5),
    opacity: 0.8,
  },
  welcomeBoxWrapper: {
    display: "flex",
    flexDirection: "column",
    height: "calc(100vh - 325px)",
    overflowY: "auto",
    overflowX: "hidden",
    "&::-webkit-scrollbar": {
      width: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
      border: "1px solid #FFFFFF",
      background: "#282945",
    },
  },
  welcomeBox: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    gap: 3,
    p: 1,
    borderTopLeftRadius: "20px",
    borderTopRightRadius: "20px",
    [theme.breakpoints.down("sm")]: {
      p: 2,
    },
  },
  chatImage: {
    width: "200px",
    height: "200px",
    opacity: 0.7,
    mb: 2,
    [theme.breakpoints.down("sm")]: {
      width: "120px",
      height: "120px",
    },
  },
  welcomeHeader: {
    ...mediumFont,
    color: "#ffffff90",
    fontSize: "30px",
    textAlign: "center",
    maxWidth: "80%",
    [theme.breakpoints.down("sm")]: {
      fontSize: "22px",
    },
  },
  footer: {
    borderBottomLeftRadius: "20px",
    borderBottomRightRadius: "20px",
    background: "rgba(255, 255, 255, 0.14)",
    backdropSFilter: "blur(24px)",
    border: "1px solid rgba(255, 255, 255, 0.21)",
    width: "calc(100% - 2px)",
    display: "flex",
    justifyContent: "start",
    zIndex: 10,
  },
  textField: {
    width: "100%",
    borderRadius: "0px",
    ".MuiOutlinedInput-notchedOutline": { border: "none !important" },
    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      border: "none !important",
    },
    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "none !important",
    },
    "& .MuiInputBase-input": {
      position: "relative",
      padding: "12px 12px",
      color: "#FFFFFF",
      borderRadius: "0px",
      fontSize: getRelativeFontSize(4),
      "&::-webkit-scrollbar": {
        width: "0px",
      },
      "&::-webkit-scrollbar-thumb": {
        borderRadius: "10px",
        border: "1px solid #FFFFFF",
        background: "#282945",
      },
      "&::placeholder": {
        ...mediumFont,
      },
    },
    "& .MuiOutlinedInput-root": {
      borderBottomRightRadius: "20px",
      borderBottomLeftRadius: "20px",
      padding: "0px 12px !important",
      "&.Mui-focused fieldset": {
        border: "none !important",
      },
    },
    "& .MuiFormHelperText-root.Mui-error": {
      fontSize: getRelativeFontSize(1),
      ...mediumFont,
    },
  },
  cardLabel: {
    ...mediumFont,
    color: "#ffffff",
    fontSize: getRelativeFontSize(4),
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(-1),
    },
  },
  selectedCardLabel: {
    ...mediumFont,
    color: "#6B72FF",
    fontSize: getRelativeFontSize(4),
    borderBottom: "2px solid #6B72FF",
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(-1),
    },
  },
  menuItems: {
    borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
    overflowX: "auto",
    whiteSpace: "nowrap",
    "&::-webkit-scrollbar": {
      height: "3px",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
      border: "1px solid #FFFFFF",
      background: "#282945",
    },
  },
  tableWrapper: {
    p: 2,
    pr: 0,
    overflowX: "auto",
    whiteSpace: "nowrap",
    "&::-webkit-scrollbar": {
      height: "3px",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
      border: "1px solid #FFFFFF",
      background: "#282945",
    },
  },
  tableLinkText: {
    ...regularFont,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "350px",
    color: "#ffffff",
    fontSize: "16px",
    textDecoration: "none",
    cursor: "pointer",
    "&:hover": {
      // textDecoration: "underline",
      opacity: 0.8,
    },
    display: "inline-block",
  },
  container: {
    height: "calc(100vh - 276px)",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    borderRadius: "20px",
  },
  header: {
    p: 2,
    borderBottom: "1px solid rgba(255, 255, 255, 0.14)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  headerTitle: {
    ...mediumFont,
    color: "#ffffff",
    fontSize: getRelativeFontSize(4),
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  newChatButton: {
    background: "#8A31FF",
    color: "#ffffff",
    width: "36px",
    height: "36px",
    "&:hover": {
      background: "#8a58cb",
    },
  },
  chatList: {
    flex: 1,
    overflow: "auto",
    "&::-webkit-scrollbar": {
      width: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
      border: "1px solid #FFFFFF",
      background: "#282945",
    },
  },
  chatItem: {
    mb: 0.5,
    borderRadius: "8px",
    "&:hover": {
      background: "rgba(255, 255, 255, 0.1)",
    },
    "&:hover .delete-button": {
      opacity: 1,
    },
  },
  activeChatItem: {
    background: "rgba(138, 49, 255, 0.2)",
    border: "1px solid rgba(138, 49, 255, 0.4)",
  },
  chatItemButton: {
    borderRadius: "8px",
    p: "8px 12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  chatName: {
    ...regularFont,
    color: "#ffffff",
    fontSize: getRelativeFontSize(2),
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    textAlign: "left",
  },
  chatDate: {
    ...regularFont,
    color: "#ffffff80",
    fontSize: getRelativeFontSize(1),
    textAlign: "left",
    mt: 0.5,
  },
  deleteButton: {
    opacity: 0,
    transition: "opacity 0.2s",
    color: "#ff4444",
    width: "24px",
    height: "24px",
    ml: 1,
    "&:hover": {
      background: "rgba(255, 68, 68, 0.1)",
    },
  },
  emptyState: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    p: 3,
    textAlign: "center",
  },
  emptyStateText: {
    ...regularFont,
    color: "#ffffff60",
    fontSize: getRelativeFontSize(2),
    mt: 2,
  },
  chatSessionText: {
    ...regularFont,
    color: "#ffffff",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "400px",
  },
  modalHeader: {
    ...regularFont,
    fontSize: getRelativeFontSize(10),
    color: "#222222",
    textAlign: "center",
  },
  selectField: {
    width: "200px",
    background: "transparent",
    borderRadius: "10px",
    backgroundClip: "content-box,border-box",
    backgroundOrigin: "border-box",
    border: "1px solid rgba(255, 255, 255, 0.14)",
    fontSize: getRelativeFontSize(4),
    ...regularFont,

    boxShadow: "none",
    ".MuiOutlinedInput-notchedOutline": { border: 0 },
    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },

    "& .MuiSelect-outlined": {
      border: "none",
      position: "relative",
      padding: "12px 12px",
      color: "#ffffff",

      "&::placeholder": {
        ...mediumFont,
        color: "##ffffffde",
      },
    },
    "& .MuiSelect-icon": {
      color: "#ffffff",
    },
    "& ..MuiOutlinedInput-notchedOutline": {
      border: "none !important",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      borderColor: "rgba(255, 255, 255, 0.14)",
      "&.Mui-focused fieldset": {
        borderColor: "rgba(255, 255, 255, 0.14)",
      },
    },
    "& .MuiInputBase-input": {
      padding: "12px",
    },
  },
  labelTypo: {
    ...regularFont,
    color: "#ffffffa6",
    fontSize: getRelativeFontSize(2),
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(0),
    },
  },
  valueTypo: {
    ...mediumFont,
    color: "#FFFFFF",
    fontSize: getRelativeFontSize(3),
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(1),
    },
  },
} as const;

export default ragChatbotStyles;
